import { computed, defineAsyncComponent } from "vue";

// 懒加载 Airwallex drop-in，避免把 @airwallex/components-sdk 打进主包

export default {
  __name: 'AirwallexDialog',
  props: {
    /** 弹窗显隐（:visible.sync 使用） */
    visible: {
      type: Boolean,
      default: false
    },
    /** 支付 intent 数据：create_payment 等接口返回 */
    data: {
      type: Object,
      required: true,
      default: () => ({})
    },
    /** 环境：'demo'（沙箱）或 'prod'（生产） */
    env: {
      type: String,
      default: () => process.env.NODE_ENV === "production" ? "prod" : "demo"
    }
  },
  emits: ["update:visible", "success", "error", "close"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const Airwallex = defineAsyncComponent(() => import("./Airwallex.vue"));
    const dialogVisible = computed({
      get: () => props.visible,
      set: val => emit("update:visible", val)
    });

    /** 弹窗关闭后：通知父组件（由父清空 intent 数据） */
    function onDialogClose() {
      emit("close");
    }
    return {
      __sfc: true,
      Airwallex,
      props,
      emit,
      dialogVisible,
      onDialogClose
    };
  }
};